import React from 'react'

interface CardProps {
  children: React.ReactNode
  className?: string
  hover?: boolean
  interactive?: boolean
  onClick?: () => void
}

export default function Card({ 
  children, 
  className = '', 
  hover = true, 
  interactive = false,
  onClick 
}: CardProps) {
  const baseClasses = 'bg-white rounded-xl shadow-md p-6'
  const hoverClasses = hover ? 'hover:shadow-xl transition-shadow duration-300' : ''
  const interactiveClasses = interactive 
    ? 'cursor-pointer hover:scale-[1.02] active:scale-[0.98] transition-transform duration-200' 
    : ''
  
  return (
    <div 
      className={`${baseClasses} ${hoverClasses} ${interactiveClasses} ${className}`}
      onClick={onClick}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={interactive && onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      } : undefined}
    >
      {children}
    </div>
  )
}

